import React, { useEffect } from "react";
import Navigation from "../Navigation";
import "../TicketsPage/style.scss";
import LeftContainer from "../TicketsPage/LeftContainer";
import useBasketManager from "../Basket/useBasketManager";
import { FINALIZE_PAGE, ZONES_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import usePassManager from "./usePassManager";
import { TicketModel } from "../../models/TicketModel";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import { Assort } from "../../models/Assort";
import Ticket from "../TicketsPage/Ticket";
import getId from "../../../utils/getId";
import ReturnButton from "../../../features/ReturnButton";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { PASS_SALE } from "../../models/TypeSale";
import { viewCart } from "../../ga4/gaMethods";
import useTypeSale from "../../../utils/hooks/useTypeSale";

const PassPage: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const { categoryBrand } = useTypeSale();
  const { loading: loadingTicket, tickets, assorts } = usePassManager();
  const { basket, setBasket, totalListPrice, removeWholeBasket, addToBasket, removeBasket } = useBasketManager(
    false,
    assorts,
    false
  );

  const navigateToFinalize = () => {
    viewCart(basket, categoryBrand, totalListPrice);
    navigate(`${FINALIZE_PAGE}?typeSale=${PASS_SALE}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Navigation>
      <div className={"sale-panel"}>
        <div className={"tickets-panel"}>
          <p className={"title"}>Wybierz voucher/bilet sezonowy</p>
          {tickets.map((item: TicketModel, index: number) => (
            <LoadableComponent loading={loadingTicket} key={index}>
              <p className={`ticket-group background-third-color`}>{item.title}</p>
              <div className={"ticket-wrapper"}>
                {item.assorts.map((assort: Assort) => (
                  <Ticket
                    key={getId(assort)}
                    colorClass={"third-color"}
                    ticket={assort}
                    onAddToBasket={addToBasket}
                    onRemoveToBasket={removeBasket}
                    basket={basket}
                    isSaleWithExercise={false}
                  />
                ))}
              </div>
            </LoadableComponent>
          ))}
          {isDesktop && <ReturnButton onClick={() => navigate(ZONES_PAGE)} />}
        </div>
        <LeftContainer
          colorClass={"third-color"}
          basket={basket}
          onRemoveToBasket={removeWholeBasket}
          updateBasket={setBasket}
          onNavigateFinalize={() => navigateToFinalize()}
          finalizeButtonText={"Przejdź do podsumowania"}
          isSaleWithExercise={false}
          totalListPrice={totalListPrice}
          isWeatherTicket={false}
        />
      </div>
    </Navigation>
  );
};

export default PassPage;
